<template>
  <div class="strategio-bgmain-view fill-height">
    <strategio-app-bar></strategio-app-bar>
    <v-main>
      <v-container>
        <v-row class="strategio-titles-windows">
          <autoservicio-btn-back title-name="Aprobar Bonificaciones"></autoservicio-btn-back>
        </v-row>
        <v-row class="justify-space-between">
          <v-col cols="6">
            <h2>Distribuidora: demo 01</h2>
          </v-col>
          <v-col cols="2">
            <v-btn
              :loading="isLoading"
              :disabled="isLoading"
              block
              color="#2262c6"
              @click="saveItems"
              class="white--text"
            >
              Guardar
              <v-icon right dark> mdi-content-save </v-icon>
        
              <template v-slot:loader>
                <span>Cargando...</span>
                <v-progress-circular
                  indeterminate
                  size="16"
                  color="primary"
                  class="ml-1"
                ></v-progress-circular>
              </template>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th v-for="(item, key) in headersTop" :key="key" :colspan="item.col" :class="item.color">{{ item.text.toUpperCase() }}</th>
                  </tr>
                  <tr class="strategio-bgtemplate-color">
                    <th v-for="(item, key) in headers" :key="key" style="color: white;">{{ item.text.toUpperCase() }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    :key="index"
                  >
                    <td v-for="(head, keyhead) in headers" :key="keyhead">
                      <v-text-field dense v-if="head.asTag == 'input'" v-model="item[head.value]">
                        <template v-slot:append>
                          <v-icon color="green" small>mdi-pencil</v-icon>
                        </template>
                      </v-text-field>
                      <v-checkbox v-else-if="head.asTag == 'check'" @change="addItem(item)" :value="validateCheckTag(item)" v-model="item[head.value]" dense :disabled="item['code_3'].length == 0"></v-checkbox>
                      <span v-else>{{ item[head.value] }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <custom-snack-bar></custom-snack-bar>
  </div>
</template>
<script>
import AutoservicioBtnBack from '../../../components/autoservicios/autoservicio-btn-back.vue'
import StrategioAppBar from '../../../components/header-bar/strategio-app-bar.vue'
import CustomSnackBar from '../../../components/snackbars/custom-snack-bar.vue'
export default {
  components: {
    StrategioAppBar,
    AutoservicioBtnBack,
    CustomSnackBar
  },
  data () {
    return {
      items: [
        { isOK: 0, code: '361640', marca: 'Elite', name: 'PH ELITE DH 24X 2 LA', qty: '15', unit: 'BOL', qty_bonus: '1', unit_2: 'BOL', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H65', tope: 65 },
        { isOK: 0, code: '361639', marca: 'Elite', name: 'PH ELITE SOFT TOUCH  DH 6 X 6', qty: '11', unit: 'BOL', qty_bonus: '2', unit_2: 'PACK', code_2: '361639', marca_2: 'Elite', name_2: 'PH ELITE SOFT TOUCH  DH 6 X 6', code_3: '132H66', tope: 30 },
        { isOK: 0, code: '361473', marca: 'Elite', name: 'PH ELITE DUO  DH 6 x 8  25 METROS', qty: '30', unit: 'BOL', qty_bonus: '1', unit_2: 'BOL', code_2: '361473', marca_2: 'Elite', name_2: 'PH ELITE DUO  DH 6 x 8  25 METROS', code_3: '132H67', tope: 80 },
        { isOK: 0, code: '361051', marca: 'Elite', name: 'PH ELITE PLUS DH 24 X 2', qty: '15', unit: 'BOL', qty_bonus: '1', unit_2: 'BOL', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H68', tope: 30 },
        { isOK: 0, code: '361618', marca: 'Noble', name: 'PH NOBLE DH 2 X 10 CON PPRECIO', qty: '3', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H88', tope: 400 },
        { isOK: 0, code: '361618', marca: 'Nobble', name: 'PH NOBLE DH 2 X 10 CON PRECIO', qty: '35', unit: 'BOL', qty_bonus: '1', unit_2: 'BOL', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H69', tope: 90 },
        { isOK: 0, code: '361415', marca: 'Nova', name: 'RC NOVA DH MEGAROLLO  1 X 12', qty: '3', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361415', marca_2: 'Nova', name_2: 'RC NOVA DH MEGAROLLO  1 XX 12', code_3: '132H70', tope: 100 },
        { isOK: 0, code: '361473', marca: 'Elite', name: 'PH ELITE DUO  DH 6 x 8  25 METROS', qty: '10', unit: 'PACK', qty_bonus: '1', unit_2: 'PACK', code_2: '361586', marca_2: 'NNova', name_2: 'SE NOVA CORTADA 200 x 15 PAQ X BOLSA', code_3: '132H72', tope: 1231 },
        { isOK: 0, code: '361436', marca: 'Higienol', name: 'PH HIGIENOL DH  4 X 12', qty: '1', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H85', tope: 400 },
        { isOK: 0, code: '361415', marca: 'Nova', name: 'RC NOVA DH MEGAROLLO  1 X 12', qty: '2', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H73', tope: 750 },
        { isOK: 0, code: '371485', marca: 'Babysec', name: 'PL PAAÑAL BABYSEC PREMIUM PPK GR 58x2ND2', qty: '30', unit: 'PACK', qty_bonus: '1', unit_2: 'PACK', code_2: '371485', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK GR 58x2ND2', code_3: '128F93', tope: 100 },
        { isOK: 0, code: '371485', marca: 'Babysec', name: 'PL PAÑAL BABYSEC PREMIUM PPK GR 58x2ND2', qty: '1', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '371481', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', code_3: '128G06', tope: 50 },
        { isOK: 0, code: '371452', marca: 'Babysec', name: 'PL PAÑAL BABYSEC PREMIUM PPK MD 64x2 ND', qty: '1', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '371481', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', code_3: '', tope: 50 },
        { isOK: 0, code: '371481', marca: 'Babysec', name: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', qty: '1', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '371481', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', code_3: '', tope: 40 },
        { isOK: 0, code: '371482', marca: 'Babysec', name: 'PL PAÑAL BABYSEC PREMIUM PPK XXG 44x2ND2', qty: '1', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '371481', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', code_3: '', tope: 40 },
        { isOK: 0, code: '371541', marca: 'Ladysoft', name: 'TF LADYSOFT NOCTURNA CON ALAS 10 X 24', qty: '6', unit: 'PACK', qty_bonus: '1', unit_2: 'PACK', code_2: '360717', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10', code_3: '132H87', tope: 400 },
        { isOK: 0, code: '371183', marca: 'Ladysoft', name: 'TF LADYSOFT NORMAL CON ALAS 10 X 24 INN', qty: '12', unit: 'BOL', qty_bonus: '8', unit_2: 'PACK', code_2: '371183', marca_2: 'Ladysoft', name_2: 'TF LADYSOFT NORMAL CON ALAS 10 X 24 INN', code_3: '128G51', tope: 80 },
        { isOK: 0, code: '371183', marca: 'Ladysoft', name: 'TF LADYSOFT NORMAL CON ALAS 10 X 24 INN', qty: '6', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '360973', marca_2: 'Elite', name_2: 'PO ELITE ALOE VERA DISPENSADOR 27 X 8', code_3: '132H93', tope: 80 },
        { isOK: 0, code: '361416', marca: 'Nova', name: 'RC NOVA DH MEGAROLLO  2 X 6', qty: '6', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361416', marca_2: 'Nova', name_2: 'RC NOVA DH MEGAROLLO  2 X 6', code_3: '132I73', tope: 250 },
        { isOK: 0, code: '361557', marca: 'Noble', name: 'PH NOBLE PREMIUM DH 4x6 40 METROS', qty: '20', unit: 'BOL', qty_bonus: '3', unit_2: 'PACK', code_2: '361557', marca_2: 'Noble', name_2: 'PH NOBLE PREMIUM DH 4x6 40 METROS', code_3: '132J38', tope: 40 },
        { isOK: 0, code: '361628', marca: 'Noble', name: 'PH NOBLE AHORRO PLUS DH 4x6 36 METROS', qty: '20', unit: 'BOL', qty_bonus: '3', unit_2: 'PACK', code_2: '361628', marca_2: 'Noble', name_2: 'PH NOBLE AHORRO PLUS DH 4x6 36 METROS', code_3: '132J39', tope: 800 }
      ],
      headersTop: [
        { text: 'Producto a evaluar', col: 4, color: 'yellow accent-4' },
        { text: 'Mecanica bonificacion', col: 9, color: 'orange lighten-1' }
      ],
      headers: [
        { text: 'Cod. Producto', value: 'code' },
        { text: 'Marca', value: 'marca' },
        { text: 'Producto', value: 'name' },
        { text: 'Unidad', value: 'unit' },
        { text: 'Cant. Minima', value: 'qty' },
        { text: 'Cod. Producto', value: 'code_2' },
        { text: 'Marca', value: 'marca_2' },
        { text: 'Producto', value: 'name_2' },
        { text: 'Unidad', value: 'unit_2' },
        { text: 'Unidades a Bonificar', value: 'qty_bonus' },
        { text: 'Cod. Pro. Distribuidor', value: 'code_3', asTag: 'input' },
        { text: 'Tope Bonificado', value: 'tope' },
        { text: '', value: 'isOK', asTag: 'check' }
      ],
      bonusItems: [],
      isLoading: false
    }
  },
  methods: {
    validateCheckTag (item) {
      return item['code_3'].length > 0 && item['isOk']
    },
    saveItems () {
      this.isLoading = true

      setTimeout(() => {
        this.isLoading = false
        this.goBack()
      }, 1000)
    },
    addItem (item) {
      // console.log(item)
    },
    goBack () {
      this.$router.back()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/routes/autoservicios/bonus/show-bonus-distributor.vue